/** 
 * @type {ComponentTypesFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    tickers: null,
    names: null,
    asset_ids: null,
}
/** 
* @returns {ComponentTypesFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ComponentTypesFilter.js